<template>
  <v-app v-if="isConnected">
    <v-snackbar
      v-model="snackbar.isOpened"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text icon
          class="ml-4"
          color="white"
          v-bind="attrs"
          @click="snackbar.isOpened = false"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <unified-user-dialog v-model="isUnifiedUserDialogOpened" />
    <v-row no-gutters justify="start" align="start" class="fill-height">
      <div class="fill-height space-selector-global-wrapper" v-if="hasMultipleSpaces">
        <v-row no-gutters justify="center" align="start" class="space-selector-global">
          <space-selector :spaces="spaces" mini />
        </v-row>
      </div>
      <v-col class="v-main-wrapper">
        <v-main>
          <topbar />
          <v-container fluid class="pa-0">
            <router-view></router-view>
          </v-container>
        </v-main>
        <v-container fluid class="app-footer">
          &copy; Indeego {{ (new Date()).getFullYear() }}
        </v-container>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Topbar from '@/components/Topbar.vue';
import SpaceSelector from '@/components/Auth/SpaceSelector.vue';
import UnifiedUserDialog from '@/components/Auth/UnifiedUserDialog.vue';

export default {
  name: `LayoutApp`,

  data: () => ({
    areDatasFetched: false,
    isUnifiedUserDialogOpened: false,
  }),

  computed: {
    ...mapState(`model/auth`, [
      `spaces`,
      `isUnifiedUser`,
    ]),
    ...mapState(`model/user`, [
      `me`,
    ]),
    ...mapState(`ui/mainLayout`, [
      `snackbar`,
    ]),
    ...mapGetters(`model/user`, [
      `hasMultipleSpaces`,
    ]),
    isConnected() {
      return Boolean(this.me && this.me.id);
    },
  },

  async beforeMount() {
    if (!this.me || !this.me.id) {
      this.$router.replace({ name: `login` });
    }
  },

  mounted() {
    if (this.isUnifiedUser) {
      setTimeout(() => {
        this.isUnifiedUserDialogOpened = true;
      }, 2000);
    }
  },

  // watch: {
  //   isUnifiedUser(isUnifiedUser) {
  //     if (isUnifiedUser) {
  //       setTimeout(() => {
  //         console.log(`POPUP !!!`, this.isUnifiedUser);
  //       }, 3000);
  //     }
  //   },
  // },

  components: {
    Topbar,
    SpaceSelector,
    UnifiedUserDialog,
  },
};
</script>

<style lang="scss" scoped>
.space-selector-global-wrapper {
  width: 70px;
  background: #FFF;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 100;
  position: relative;
  .space-selector-global {
    position: fixed;
    width: 70px;
    background: transparent;
    top: 0;
    left: 0;
    bottom: 0;
  }
}
.v-main-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
